import { useRef } from "react";

/**
 * Горизонтальная прокрутка «свайпом» мышью на десктопе: зажал — потянул.
 * Пальцу это не нужно — тач-экран листает overflow-контейнер сам, поэтому
 * обрабатываем только `pointerType === "mouse"`. Клик после перетаскивания
 * гасим, иначе отпущенная над чипом кнопка срабатывала бы как нажатие.
 */
export function useDragScroll<T extends HTMLElement>() {
  const state = useRef({ down: false, moved: false, x: 0, left: 0 });

  const onPointerDown = (e: React.PointerEvent<T>) => {
    if (e.pointerType !== "mouse") return;
    state.current = { down: true, moved: false, x: e.clientX, left: e.currentTarget.scrollLeft };
  };

  const onPointerMove = (e: React.PointerEvent<T>) => {
    const s = state.current;
    if (!s.down) return;
    const dx = e.clientX - s.x;
    if (Math.abs(dx) > 4) s.moved = true;
    e.currentTarget.scrollLeft = s.left - dx;
  };

  const end = () => {
    state.current.down = false;
  };

  const onClickCapture = (e: React.MouseEvent<T>) => {
    if (state.current.moved) {
      e.stopPropagation();
      e.preventDefault();
      state.current.moved = false;
    }
  };

  const onWheel = (e: React.WheelEvent<T>) => {
    // Колесо крутит только вертикаль — переводим в горизонталь.
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.currentTarget.scrollLeft += e.deltaY;
    }
  };

  return {
    onPointerDown,
    onPointerMove,
    onPointerUp: end,
    onPointerLeave: end,
    onPointerCancel: end,
    onClickCapture,
    onWheel,
  };
}
